module.exports = __webpack_public_path__ + "assets/icons/translated_with_DeepL_FR-b220.svg";